// extracted by mini-css-extract-plugin
export default {"toggleWrapper":"OneSessionToggle_toggleWrapper__f+PsM","toggleButton":"OneSessionToggle_toggleButton__MCvgx"};